<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="startFindingMemberIdDataWithCode">{{
        $t("find_member_data")
      }}</mdb-btn>
    </mdb-form-inline>
    <InputModal
      :characterMinLimit="2"
      :modalShow="memberSearchModal"
      :dataShow="dataLoadReady"
      :title="$t('find_member_id_modal_title')"
      :description="$t('find_member_id_modal_description')"
      :inputLabel="$t('find_member_id_modal_inputlabel')"
      :buttontext="$t('find_member_id_modal_button')"
      :button-delete-text="$t('delete_member_id_modal_button')"
      :dataModal="dataModal"
      v-on:modal-cancelled="MemberIdSearchCancelled"
      v-on:modal-ok="MemberIdSearch"
      v-on:modal-delete="deleteMemberIdData"
    />
  </div>
</template>

<script>
import { mdbBtn, mdbFormInline } from "mdbvue";
import InputModal from "./InputModal.vue";
export default {
  name: "FindMemberIds",
  components: {
    mdbBtn,
    mdbFormInline,
    InputModal,
  },
  data() {
    return {
      filterText: "",
      memberSearchModal: false,
      dataLoadReady: false,
      dataModal: {
        columns: [
          {
            label: "Id",
            field: "id",
          },
          {
            label: "Jäsennumero",
            field: "surrogate",
          },
          {
            label: "Nimi",
            field: "name",
          },
          {
            label: "Luotu",
            field: "created",
          },
          {
            label: "Puhelinnumero",
            field: "tel",
          },
          {
            label: "Sähköposti",
            field: "email",
          },
        ],
        rows: null,
      },
      retrievebypath: "/1.0/front/customer/retrieve/surrogate/",
      deletecustomerpath: "/1.0/front/customer/surrogate/delete",
    };
  },
  methods: {
    MemberIdSearchCancelled() {
      this.memberSearchModal = false;
    },
    MemberIdSearch(val) {
      this.dataLoadReady = false;
      this.findMemberIdDataWithCode(val);
    },
    deleteMemberIdData(val) {
      this.$http
        .post(this.deletecustomerpath, { surrogate: val })
        .then((response) => {
          if (response.status == 200) {
            this.dataLoadReady = false;
            this.$notify.info({
              message: this.$t("member_id_deleted"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    startFindingMemberIdDataWithCode() {
      this.memberSearchModal = true;
    },
    findMemberIdDataWithCode(val) {
      this.$http
        .get(this.retrievebypath + val)
        .then((response) => {
          if (response.status == 200) {
            this.dataModal.rows = response.data.customers;
            this.dataLoadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
  },
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
